import { NodeModel } from '@projectstorm/react-diagrams';
import { ConstantPortModel } from './ConstantPortModel';
import _ from 'lodash';
import { CONSTPORT } from "../ConstantNames";
import { BinaryLinkModel } from "../../links/binary/BinaryLinkModel";
export class ConstantNodeModel extends NodeModel {
  constructor(options = {}, color, reduxProps) {
    if (typeof options === 'string') {
      options = {
        name: options,
        previousName: options,
        color: color,
        reduxProps: reduxProps
      };
    }

    super({
      type: 'constant',
      name: 'Untitled',
      color: 'rgb(92,192,125)',
      ...options
    });
    this.mainPort = this.setUpConstantPort();
    this.editable = reduxProps["editable"];
    this.registerEvents();
  }

  setUpConstantPort() {
    let port = new ConstantPortModel(CONSTPORT);
    this.addPort(port);
    return port;
  }

  removeAllLinks() {
    for (let link of _.values(this.getMainPort().getLinks())) {
      link.remove();
    }
  }

  getReduxProps() {
    return this.options.reduxProps;
  }

  isEditable() {
    return this.editable;
  }

  changeEditableState(value) {
    this.editable = value;
  }

  setConstantValueInMathView(domainNodeName) {
    this.options.reduxProps["setConstantValueFromLink"](this.getNodeName(), domainNodeName);
  }

  removeNodeFromMathView() {
    this.options.reduxProps["removeConstantNode"](this.getNodeName());
  }

  registerEvents() {
    let node = this;
    this.registerListener({
      entityRemoved(event) {
        for (let link of _.values(node.getMainPort().getLinks())) {
          if (link instanceof BinaryLinkModel) {
            link.setCallReduxFunc(false);
          }
        }

        node.removeNodeFromMathView();
      }

    });
  }

  getMainPort() {
    return this.mainPort;
  }

  getNodeName() {
    return this.options.name;
  }

  renameNode(name) {
    this.options.name = name;
  }

  removePort(port) {
    for (let link of _.values(port.getLinks())) {
      link.remove();
    } //clear the parent node reference


    if (this.ports[port.getName()]) {
      this.ports[port.getName()].setParent(null);
      delete this.ports[port.getName()];
    }
  }

  serialize() {
    return { ...super.serialize(),
      editable: this.editable
    };
  }

  deserialize(event) {
    super.deserialize(event);
    this.editable = event.data.editable;
  }

}